<template>
  <div class="head">
    <div class="head-content">
      <div class="left_image">
        <img
          class="left_image__img"
          src="@/assets/images/logo.png"
          alt=""
          @click="goHome()"
        />
      </div>
      <!-- <ul>
          <li
            v-for="(item, index) of topicList"
            :key="index"
            :class="{ active: index==curIndex }"
            @click="indexState(item,index)"
          >
            {{ (item.name) }}
          </li>
        </ul> -->
      <div class="right">
        <!-- <div class="right_icon1" style="visibility: hidden;">
            <img  class="right_icon1_img" 
            :src="currentImageSrc1" 
            alt="" 
            @mouseenter="changeImage1"
            @mouseleave="resetImage1"/>
           </div> -->

        <div class="right_btn" @click="isPublishClick = !isPublishClick">
          我要招聘
        </div>

        <div
          class="right_icon2"
          @mouseenter="changeImage2"
          @mouseleave="resetImage2"
          v-if="!isLogin"
          @click="requestGetGithub()"
        >
          <img :src="currentImageSrc2" class="right_icon2__img" alt="" />
          登录
        </div>

        <div v-else class="right_icon3" @click="isLoginClick = !isLoginClick">
          <img :src="githubInfo.avatar_url" class="right_icon3__img" alt="" />
          <div class="right_icon3__text">{{ githubInfo.account }}</div>
        </div>

        <el-popover
          class="popoverDialog"
          v-model="isLoginClick"
          placement="bottom"
          width="160"
          trigger="hover"
        >
          <div class="popoverDialog__text" @click="jobApply()">招聘管理</div>
          <div class="popoverDialog__text" @click="requestLoginOut()">
            退出登录
          </div>
        </el-popover>

        <el-popover
          class="popoverDialog2"
          v-model="isPublishClick"
          placement="bottom"
          width="160"
          trigger="hover"
        >
          <div class="popoverDialog__text" @click="jobPost(1)">发布招聘</div>
          <div class="popoverDialog__text" @click="jobPost(2)">
            发布外包任务
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script >
import { getGithub } from "@/config/api.js";
import headerBase from "./header.base.js";
import { getCategoryList } from "@/config/api.js";
import Vue from "vue";
import { Popover, Message } from "element-ui";
Vue.use(Popover);
Vue.prototype.$message = Message;
export default {
  mixins: [headerBase],
  components: {},
  data() {
    return {
      topicList: [],
      searchValue: "",
      searchFocus: false,
      lang: "",
      language: [
        {
          label: "中文",
          value: "cn",
        },
        {
          label: "英文",
          value: "en",
        },
      ],
      dialogVisible: false,
      isActiveHeadPC: false,
      curIndex: 0,

      defaultImageSrc1: require("@/assets/images/head_icon2.png"),
      hoverImageSrc1: require("@/assets/images/head_icon2s.png"),
      currentImageSrc1: require("@/assets/images/head_icon2.png"),

      defaultImageSrc2: require("@/assets/images/head_icon1.png"),
      hoverImageSrc2: require("@/assets/images/head_icon1s.png"),
      currentImageSrc2: require("@/assets/images/head_icon1.png"),

      isLogin: false,
      isLoginClick: false,
      isPublishClick: false,
      code: "", // 第三方返回code
      githubInfo: {}, // 登录信息
      githubToken: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    indexState: function (item, index) {
      this.curIndex = index;
      if (this.$route.path != "/") {
        this.$router.push({
          path: "/",
        });
      } else {
        // document.getElementById('tutorial'+this.curIndex).scrollIntoView();
      }

      // //标题栏的
      // if (item.slug) {
      //   this.$router.push({ path: "/" + item.slug ,  query: {
      //     type: item.id,
      //   },});
      // } else {
      //   this.$router.push({
      //     path: "/",
      //     query: {
      //     type: item.id,
      //   },
      //   });
      // }
    },
    goHome() {
      var that = this;
      if (
        that.$route.path == "/tempDetail" &&
        that.$route.query.hasOwnProperty("refresh")
      ) {
        that.$router.push({
          path: "/tempMore",
          query: { refresh: "1" },
        });
      } else {
        that.$router.push({
          path: "/",
          query: { refresh: "1" },
        });
      }
    },
    showIcon() {
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 100
      ) {
        this.isActiveHeadPC = false;
      } else {
        this.isActiveHeadPC = true;
      }
    },
    // 总类类别
    requestGetCategoryList() {
      getCategoryList().then((res) => {
        this.topicList = [{ id: 0, name: "首页", slug: "index" }];
        if (res.data) {
          res.data.forEach((element) => {
            this.$set(this.topicList, this.topicList.length, {
              id: element.ID,
              name: element.Name,
              slug: element.Slug,
            });
          });
        }
      });
    },
    changeImage1() {
      this.currentImageSrc1 = this.hoverImageSrc1;
    },
    resetImage1() {
      this.currentImageSrc1 = this.defaultImageSrc1;
    },
    changeImage2() {
      this.currentImageSrc2 = this.hoverImageSrc2;
    },
    resetImage2() {
      this.currentImageSrc2 = this.defaultImageSrc2;
    },
    // 请求第三方登录
    requestGetGithub() {
      // 清空github信息
      localStorage.setItem("github", "");
      localStorage.setItem("githubToken", "");

      const url =
        "https://github.com/login/oauth/authorize?client_id=Ov23liWdX37xSNpZg85N&redirect_uri=http://job.hitadao.com/";
      window.location.href = url;
    },
    // 请求登录信息
    requestGetGithubInfo() {
      var that = this;
      getGithub({ code: that.code, appType: "jobs" }).then((res) => {
        if (res.code == 200200) {
          that.isLogin = true;
          that.githubInfo = res.data.account;
          that.githubToken = res.data.token;

          // 存储github信息
          localStorage.setItem("github", JSON.stringify(that.githubInfo));
          // 存储githubToken信息
          localStorage.setItem("githubToken", that.githubToken);
        }
      });
    },
    // 退出登录
    requestLoginOut() {
      var that = this;

      // 清空github信息
      localStorage.setItem("github", "");
      localStorage.setItem("githubToken", "");

      that.isLoginClick = false;
      that.isLogin = false;

      that.goHome();
    },
    // 发布招聘
    jobPost(type) {
      var that = this;

      // 读取github信息
      const savedString = localStorage.getItem("github");
      if (savedString != "" && savedString != null) {
        if (type == 1) {
          that.$router.push({
            path: "/post",
          });
        } else {
          that.$router.push({
            path: "/tempPost",
          });
        }
      } else if (savedString == "" || savedString == null) {
        that.$message({
          message: "请先登录Github",
          type: "warning",
          duration: 3000,
        });
      }
    },
    jobApply() {
      var that = this;
      that.$router.push({
        path: "/apply",
        query: { refresh: "1" },
      });
    },
  },
  mounted() {
    var that = this;
    window.addEventListener("scroll", this.showIcon);

    var queryData = this.$route.query;
    if (queryData.hasOwnProperty("code")) {
      that.code = queryData.code;
      that.requestGetGithubInfo();
    }

    // 读取github信息
    const savedString = localStorage.getItem("github");
    if (savedString != "" && savedString != null) {
      that.githubInfo = JSON.parse(savedString);
      that.isLogin = true;
    }
  },
  beforeMount() {},
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 60px;
  background: #ffffff;
  display: flex;
  position: fixed;
  z-index: 110;
  padding: 0 10% 0 10%;
  top: 0;

  .head-content {
    height: 60px;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left_image {
      width: 205px;
      height: 61px;
      &__img {
        width: 205px;
        height: 61px;
        object-fit: contain;
        cursor: pointer;
      }
    }

    ul {
      height: 60px;
      width: auto;
      text-align: center;
      line-height: 60px;
      position: relative;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;

      li {
        width: auto;
        margin: 0 0 0 0;
        font-size: 15px;
        height: 60px;
        line-height: 60px;
        border-radius: 2px;
        text-align: center;
        font-family: Arial-BoldMT;
        font-family: ArialMT;
        padding: 0px 10px;
        color: #b2b2b2;
        font-weight: 500;
        cursor: pointer;
      }

      li:hover {
        color: #000000;
      }

      .active {
        height: 26px;
        line-height: 26px;
        // margin: 17px 0 17px 4%;
        color: #ffffff;
        background: #689bff;
        border-radius: 20px 20px 20px 20px;
      }
    }

    .right {
      width: auto;
      min-width: 240px;
      height: 60px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .right_icon1 {
        display: flex;
        justify-content: center;
        align-items: center;
        &_img {
          width: 25px;
          height: 60px;
          object-fit: contain;
          cursor: pointer;
        }
      }

      .right_icon2 {
        width: 80px;
        height: 36px;
        border-radius: 20px 20px 20px 20px;
        border: 2px solid #000000;

        font-weight: normal;
        font-size: 14px;
        color: #000000;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 0 9px 0 9px;
        margin: 0 0 0 0;

        &__img {
          width: 24px;
          height: 24px;
          object-fit: contain;
          cursor: pointer;
          margin: 0 5px 0 0;
        }
      }

      .right_icon2:hover {
        border: 2px solid #689bff;
        color: #689bff;
      }

      .right_btn {
        width: auto;
        height: 36px;
        border-radius: 60px 60px 60px 60px;
        border: 2px solid #000000;
        padding: 0 20px 0 20px;
        margin: 0 12% 0 0;

        font-weight: normal;
        font-size: 14px;
        color: #000000;
        line-height: 32px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        cursor: pointer;
      }

      .right_btn:hover {
        border: 2px solid #689bff;
        color: #689bff;
      }

      .right_icon3 {
        width: 120px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 0 0;
        cursor: pointer;

        &__img {
          width: 32px;
          height: 32px;
          object-fit: contain;
          border-radius: 50%;
        }
        &__text {
          width: 80px;

          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          margin: 0 0 0 6px;
        }
      }

      .popoverDialog {
        margin: 65px 0 0 -160px;

        &__text {
          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 40px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
        &__text:hover {
          color: rgba(104, 155, 255, 1);
        }
        .el-popover {
          width: 160px;
          height: 170px;
          background: #ffffff;
          box-shadow: 0px 14px 16px 0px rgba(0, 0, 0, 0.05);
          border-radius: 8px 8px 8px 8px;
        }
      }

      .popoverDialog2 {
        margin: 65px 0 0 -80px;

        &__text {
          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 40px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
        &__text:hover {
          color: rgba(104, 155, 255, 1);
        }
        .el-popover {
          width: 160px;
          height: 170px;
          background: #ffffff;
          box-shadow: 0px 14px 16px 0px rgba(0, 0, 0, 0.05);
          border-radius: 8px 8px 8px 8px;
        }
      }
    }
  }
}

@media screen and (max-width: 958px) {
  .head {
    width: 100%;
    height: 60px;
    background: #ffffff;
    display: flex;
    position: fixed;
    z-index: 110;
    padding: 0 2% 0 2%;
    top: 0;

    .head-content {
      height: 60px;
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left_image {
        width: 125px;
        height: 61px;
        &__img {
          width: 125px;
          height: 61px;
          object-fit: contain;
          cursor: pointer;
        }
      }

      ul {
        height: 60px;
        width: auto;
        text-align: center;
        line-height: 60px;
        position: relative;
        z-index: 10;
        display: none;
        align-items: center;
        justify-content: center;

        li {
          width: auto;
          margin: 0 0 0 0;
          font-size: 15px;
          height: 60px;
          line-height: 60px;
          border-radius: 2px;
          text-align: center;
          font-family: Arial-BoldMT;
          font-family: ArialMT;
          padding: 0px 10px;
          color: #b2b2b2;
          font-weight: 500;
          cursor: pointer;
        }

        li:hover {
          color: #000000;
        }

        .active {
          height: 26px;
          line-height: 26px;
          // margin: 17px 0 17px 4%;
          color: #ffffff;
          background: #689bff;
          border-radius: 20px 20px 20px 20px;
        }
      }

      .right {
        width: auto;
        min-width: 240px;
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .right_icon1 {
          display: flex;
          justify-content: center;
          align-items: center;
          &_img {
            width: 25px;
            height: 60px;
            object-fit: contain;
            cursor: pointer;
          }
        }

        .right_icon2 {
          width: 80px;
          height: 36px;
          border-radius: 20px 20px 20px 20px;
          border: 2px solid #000000;

          font-weight: normal;
          font-size: 14px;
          color: #000000;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;

          display: flex;
          justify-content: space-between;
          align-items: center;

          padding: 0 9px 0 9px;
          margin: 0 0 0 0;

          &__img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            cursor: pointer;
            margin: 0 5px 0 0;
          }
        }

        .right_icon2:hover {
          border: 2px solid #689bff;
          color: #689bff;
        }

        .right_btn {
          width: auto;
          height: 36px;
          border-radius: 60px 60px 60px 60px;
          border: 2px solid #000000;
          padding: 0 20px 0 20px;
          margin: 0 12% 0 0;

          font-weight: normal;
          font-size: 14px;
          color: #000000;
          line-height: 32px;
          text-align: center;
          font-style: normal;
          text-transform: none;

          cursor: pointer;
        }

        .right_btn:hover {
          border: 2px solid #689bff;
          color: #689bff;
        }

        .right_icon3 {
          width: 120px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 0 0 0;
          cursor: pointer;

          &__img {
            width: 32px;
            height: 32px;
            object-fit: contain;
            border-radius: 50%;
          }
          &__text {
            width: 80px;

            font-weight: normal;
            font-size: 12px;
            color: #000000;
            line-height: 40px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            margin: 0 0 0 6px;
          }
        }

        .popoverDialog {
          margin: 65px 0 0 -160px;

          &__text {
            font-weight: normal;
            font-size: 12px;
            color: #000000;
            line-height: 40px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          &__text:hover {
            color: rgba(104, 155, 255, 1);
          }

          .el-popover {
            width: 160px;
            height: 170px;
            background: #ffffff;
            box-shadow: 0px 14px 16px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px 8px 8px 8px;
          }
        }

        .popoverDialog2 {
          margin: 65px 0 0 -80px;

          &__text {
            font-weight: normal;
            font-size: 12px;
            color: #000000;
            line-height: 40px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
          }
          &__text:hover {
            color: rgba(104, 155, 255, 1);
          }
          .el-popover {
            width: 160px;
            height: 170px;
            background: #ffffff;
            box-shadow: 0px 14px 16px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px 8px 8px 8px;
          }
        }
      }
    }
  }
}
</style>
